var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeavyRainShower01 = function SvgHeavyRainShower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heavy_rain_shower-01_svg2__a",
    x1: 19.64,
    x2: 164.44,
    y1: 173.43,
    y2: 28.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain_shower-01_svg2__a",
    id: "heavy_rain_shower-01_svg2__b",
    x1: 44.21,
    x2: 189.01,
    y1: 198,
    y2: 53.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain_shower-01_svg2__a",
    id: "heavy_rain_shower-01_svg2__c",
    x1: 68.78,
    x2: 213.58,
    y1: 222.56,
    y2: 77.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain_shower-01_svg2__a",
    id: "heavy_rain_shower-01_svg2__d",
    x1: 48.76,
    x2: 193.56,
    y1: 202.55,
    y2: 57.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain_shower-01_svg2__a",
    id: "heavy_rain_shower-01_svg2__e",
    x1: 75.64,
    x2: 220.44,
    y1: 229.43,
    y2: 84.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain_shower-01_svg2__a",
    id: "heavy_rain_shower-01_svg2__f",
    x1: 12.12,
    x2: 156.92,
    y1: 165.9,
    y2: 21.1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M55.67 126.58c-12.92 2.84-22.22 10.47-23.67 19.45-.91 5.63 1.52 10.77 6.5 13.73 6.37 3.79 13.89 1.82 18.25-3.98 2.28-3.04 7.12-11.74 2.73-26.94a3.245 3.245 0 0 0-3.81-2.27m-4.1 25.32c-2.35 3.12-6.19 4.42-9.74 2.3-2.69-1.6-3.9-4.13-3.42-7.12 1.03-6.34 8.15-11.04 15.6-13.34 1.53 7.39.67 14.03-2.44 18.16",
    style: {
      fill: "url(#heavy_rain_shower-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.81 126.58c-12.93 2.84-22.22 10.47-23.67 19.45-.91 5.63 1.52 10.77 6.5 13.73 6.37 3.79 13.89 1.82 18.25-3.98 2.28-3.04 7.12-11.74 2.73-26.94a3.24 3.24 0 0 0-3.81-2.27m-4.1 25.32c-2.38 3.17-6.22 4.4-9.74 2.3-2.69-1.6-3.9-4.13-3.42-7.12 1.03-6.34 8.15-11.04 15.6-13.34 1.53 7.39.67 14.03-2.44 18.16",
    style: {
      fill: "url(#heavy_rain_shower-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.76 128.85a3.245 3.245 0 0 0-3.81-2.27c-12.92 2.84-22.22 10.47-23.67 19.45-.91 5.63 1.52 10.77 6.51 13.73 6.37 3.79 13.9 1.81 18.25-3.98 2.28-3.04 7.12-11.74 2.73-26.94m-7.92 23.05c-2.34 3.12-6.19 4.42-9.74 2.3-2.69-1.6-3.9-4.13-3.42-7.12 1.03-6.34 8.15-11.04 15.6-13.34 1.53 7.39.67 14.03-2.44 18.16",
    style: {
      fill: "url(#heavy_rain_shower-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.23 160.26c-12.92 2.84-22.21 10.47-23.67 19.45-.91 5.63 1.52 10.77 6.5 13.73 6.37 3.79 13.89 1.82 18.25-3.98 2.28-3.04 7.12-11.74 2.73-26.94a3.245 3.245 0 0 0-3.81-2.27m-4.1 25.32c-2.35 3.12-6.19 4.42-9.74 2.3-2.69-1.6-3.9-4.13-3.42-7.12 1.03-6.34 8.15-11.04 15.6-13.34 1.53 7.39.67 14.03-2.44 18.16",
    style: {
      fill: "url(#heavy_rain_shower-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.38 164.88c-12.92 2.83-22.22 10.47-23.67 19.45-.91 5.63 1.52 10.77 6.5 13.74 6.31 3.76 13.87 1.85 18.25-3.98 2.28-3.04 7.12-11.74 2.73-26.94a3.24 3.24 0 0 0-3.81-2.27m-4.1 25.3c-2.34 3.12-6.19 4.42-9.74 2.3-2.69-1.6-3.9-4.13-3.42-7.12 1.03-6.34 8.15-11.04 15.6-13.34 1.53 7.39.67 14.03-2.44 18.16",
    style: {
      fill: "url(#heavy_rain_shower-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.28 28.87c-3.21 0-6.5.43-9.96 1.32C133.85 11.74 115.75 0 95.3 0 72.66 0 52.81 14.49 45.91 36.06a3.7 3.7 0 0 0 2.4 4.66c1.96.63 4.04-.45 4.66-2.4C58.89 19.84 75.9 7.42 95.3 7.42c17.24 0 32.55 9.77 39.94 25.18-5.09 2.33-8.61 5.76-10.77 8.51a3.71 3.71 0 0 0 .62 5.21c.68.54 1.49.8 2.29.8 1.1 0 2.18-.48 2.91-1.41 2.01-2.55 5.53-5.91 10.91-7.45.02 0 .1-.03.13-.04 3.95-1.29 7.53-1.92 10.95-1.92 19.59 0 35.53 15.94 35.53 35.53s-15.94 35.53-35.53 35.53H38.95c-14.76 0-26.76-12-26.76-26.76S24.2 53.84 38.95 53.84c2.18 0 4.46.35 7.16 1.11 3.55 1.07 6.84 2.99 9.28 5.41.73.72 1.67 1.08 2.61 1.08s1.9-.37 2.63-1.09a3.7 3.7 0 0 0-.02-5.24c-3.29-3.27-7.69-5.85-12.39-7.27h-.04c-.01 0-.02-.01-.03-.02-3.4-.95-6.32-1.4-9.21-1.4-18.85 0-34.18 15.33-34.18 34.18s15.33 34.18 34.18 34.18h113.33c23.68 0 42.95-19.26 42.95-42.95 0-23.68-19.26-42.95-42.95-42.95",
    style: {
      fill: "url(#heavy_rain_shower-01_svg2__f)"
    }
  }));
};
export default SvgHeavyRainShower01;